// The phone draws its own layout for these screens and finds them by title, so the host and the phone
// read the same strings rather than two copies that can drift.
export const MAIN_MENU_TITLE = 'Main Menu';
export const SONG_SETTINGS_TITLE = 'Song Settings';
export const MIC_SETUP_TITLE = 'Setup microphones';
